import React from 'react';
import { StyleSheet, View } from 'react-native';
import { BodyText, Button, IconLink, theme } from '@sg/garnish';

/**
 * Warning message for the bag.
 */
export const BagWarning = (props: BagRewardWarningProps) => {
  const {
    message,
    cta,
    accessibilityLabel,
    closeAccessibilityLabel,
    onClose,
    onCtaPress,
  } = props;

  return (
    <View style={styles.container}>
      <IconLink
        name="IconClose"
        palette="muted"
        style={styles.closeCta}
        accessibilityLabel={closeAccessibilityLabel}
        onPress={onClose}
      />

      <BodyText sizeMatch={['24']}>{message}</BodyText>

      <Button
        size="large-wide"
        palette="primaryOutline"
        accessibilityLabel={accessibilityLabel}
        onPress={onCtaPress}
      >
        <BodyText style={styles.ctaColor} sizeMatch={['18']}>
          {cta}
        </BodyText>
      </Button>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    paddingTop: theme.spacing['4'],
    paddingHorizontal: theme.spacing['4'],
    paddingBottom: theme.spacing['10'],
    gap: theme.spacing['6'],
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeCta: {
    width: 40,
    height: 40,
    alignSelf: 'flex-end',
  },
  ctaColor: {
    color: theme.colors.KALE,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type BagRewardWarningProps = {
  message: string;
  cta: string;
  accessibilityLabel: string;
  closeAccessibilityLabel: string;
  onClose: () => void;
  onCtaPress: () => void;
};
